import Text from '@shared/components/Text';
import IconLink from '@shared/svg/Link';
import type { SuggestionType } from '~/types/chat';
import * as styles from './styles';

type Props = {
  item: SuggestionType;
  onClick: (item: SuggestionType) => void;
  children?: React.ReactNode;
  [key: string]: any;
};

export default function SuggestionItem({ item, onClick, children }: Props) {
  const { label, link } = item;
  return (
    <button css={styles.container} onClick={() => onClick(item)}>
      <Text bold size="sm" leading="sm">
        {label}
      </Text>
      {!!link && <IconLink />}
    </button>
  );
}
